import { render, staticRenderFns } from "./BlackBtn.vue?vue&type=template&id=55ad3ece&scoped=true&functional=true&"
import script from "./BlackBtn.vue?vue&type=script&lang=js&"
export * from "./BlackBtn.vue?vue&type=script&lang=js&"
import style0 from "./BlackBtn.vue?vue&type=style&index=0&id=55ad3ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "55ad3ece",
  null
  
)

export default component.exports